// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { PrimaryText } from '../../Typography.jsx';
import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';
import { PrimaryButton } from '../../Buttons.jsx';

import ProblemTable from './ProblemTable.jsx';
import MedicationTable from '../treatment/MedicationTable.jsx';
import InterventionTable from '../treatment/InterventionTable.jsx';

type Props = {
  print: boolean,
}

class CurrentProblemsPageComponent extends Component<Props> {
  render() {
    return (
      <div>
        <PageHeader title="Current Diagnoses & Treatments" />
        {!this.props.print
          && (<ContentBox>
            <Link to={'./newDiagnosis'}>
              <PrimaryButton>New Diagnosis</PrimaryButton>
            </Link>
          </ContentBox>)
        }
        <ContentBox title='Acute Diagnoses & Treatments' id='acute'>
          <PrimaryText>Acute Diagnoses</PrimaryText><br />
          <ProblemTable current acute /><br />
          <PrimaryText>Acute Medications</PrimaryText><br />
          <MedicationTable current acute /><br />
          <PrimaryText>Acute Interventions</PrimaryText><br />
          <InterventionTable current acute />
        </ContentBox>
        <ContentBox title='Chronic Diagnoses & Treatments' id='chronic'>
          <PrimaryText>Chronic Diagnoses</PrimaryText><br />
          <ProblemTable current chronic /><br />
          <PrimaryText>Chronic Medications</PrimaryText><br />
          <MedicationTable current chronic /><br />
          <PrimaryText>Chronic Interventions</PrimaryText><br />
          <InterventionTable current chronic />
        </ContentBox>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  print: state.patient.print,
});

const CurrentProblemsPage = connect(
  mapStateToProps,
)(CurrentProblemsPageComponent);

export default CurrentProblemsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/problem/CurrentProblemsPage.jsx